/**
 * 时间工具函数 - 墨西哥时间处理
 */

/**
 * 格式化墨西哥时间显示（数据库存储的已经是墨西哥时间）
 * @param mexicoTimeString 墨西哥时间字符串 (ISO格式)
 * @returns 格式化的墨西哥时间字符串
 */
export const formatMexicoTime = (mexicoTimeString: string): string => {
  if (!mexicoTimeString) return '-';
  
  try {
    const date = new Date(mexicoTimeString);
    
    // 直接格式化显示，不需要时区转换
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    
    return date.toLocaleString('zh-CN', options);
  } catch (error) {
    console.error('时间格式化错误:', error);
    return mexicoTimeString;
  }
};

/**
 * 获取当前墨西哥时间
 * @returns 当前墨西哥时间的Date对象
 */
export const getCurrentMexicoTime = (): Date => {
  const now = new Date();
  // 转换为墨西哥时间
  return new Date(now.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
};

/**
 * 将日期转换为墨西哥时间并格式化
 * @param date Date对象
 * @returns 格式化的墨西哥时间字符串
 */
export const formatDateToMexicoTime = (date: Date): string => {
  const mexicoOptions: Intl.DateTimeFormatOptions = {
    timeZone: 'America/Mexico_City',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  };
  
  return date.toLocaleString('zh-CN', mexicoOptions);
};

/**
 * 计算墨西哥时间的周统计
 * @param tasks 任务列表
 * @returns 周统计数据
 */
export const calculateMexicoWeekStats = (tasks: any[]) => {
  const now = getCurrentMexicoTime();
  const currentWeekStart = new Date(now);
  currentWeekStart.setDate(now.getDate() - now.getDay() + 1); // 本周一
  currentWeekStart.setHours(0, 0, 0, 0);
  
  const lastWeekStart = new Date(currentWeekStart);
  lastWeekStart.setDate(currentWeekStart.getDate() - 7); // 上周一
  
  const lastWeekEnd = new Date(lastWeekStart);
  lastWeekEnd.setDate(lastWeekStart.getDate() + 6); // 上周日
  lastWeekEnd.setHours(23, 59, 59, 999);
  
  const currentWeekEnd = new Date(currentWeekStart);
  currentWeekEnd.setDate(currentWeekStart.getDate() + 6); // 本周日
  currentWeekEnd.setHours(23, 59, 59, 999);

  // 计算本周和上周每日数据
  const currentWeekDaily = Array(7).fill(0);
  const lastWeekDaily = Array(7).fill(0);

  tasks.forEach(task => {
    if (task.status !== 'completed') return;
    
    const taskDate = new Date(task.created_at);
    const dayOfWeek = taskDate.getDay(); // 0=周日, 1=周一, ..., 6=周六
    const adjustedDay = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // 调整为周一=0, 周日=6
    
    const newPhonesAdded = task.new_phones_added || 0;
    
    if (taskDate >= currentWeekStart && taskDate <= currentWeekEnd) {
      currentWeekDaily[adjustedDay] += newPhonesAdded;
    } else if (taskDate >= lastWeekStart && taskDate <= lastWeekEnd) {
      lastWeekDaily[adjustedDay] += newPhonesAdded;
    }
  });

  return { currentWeekDaily, lastWeekDaily };
};
